import styled from "styled-components";
import { BreakpointKey } from "theme/breakpoints";

/**
 * Place commonly used container/wrapper components in this file.
 *
 * @note - exports in this file should be pure styled components,
 *         not compositions. Compositions should be written in their
 *         own file as a standalone component.
 *
 * @example - wrapper used to responsively display elements
 * @example - div container that display a card with an inset border
 */

export const DesktopImageContainer = styled.div`
  position: relative;
  display: none;

  ${({ $breakpoint, theme }) => theme.media[$breakpoint || BreakpointKey.LG]} {
    display: block;
  }
`;

export const MobileImageContainer = styled.div`
  position: relative;
  ${({ $breakpoint, theme }) => theme.media[$breakpoint || BreakpointKey.LG]} {
    display: none;
  }
`;
